export default __webpack_public_path__ + "static/media/userIcon.5f713405.svg";